<template>
  <div v-if="showTitle" class="title mt-3 px-3">
    <span class="orange-title">{{ translateFreeTour.PlansOrangeTitle }}</span>
    <span class="black-title px-2">{{ translateFreeTour.PlansBlackTitle }}</span>
  </div>
  <div v-if="showTitle" class="subtitle mt-3 px-3">
    <span>{{ translateFreeTour.PlansSubTitle }}</span>
  </div>
  <div class="list-plans ps-3 pt-3">
    <div class="row mt-3" v-for="item in plans" :key="item.id">
      <div class="col-4">
        <div class="row d-flex">
          <div v-if="item.discount > 0" class="col-lg-5 col-12 discont-w">
            <span class="discont">{{ item.discount }}% OFF</span>
          </div>
          <div v-else class="col-lg-5 col-12"></div>
          <div class="col-lg-5 col-12 d-w">
            <span class="plan-name"> {{ item.period }} </span>
          </div>
        </div>
      </div>
      <div class="col-5">
        <div class="row d-flex">
          <div class="col-lg-5 col-12 d-w">
            <span class="value">{{ locale === 'pt-br' ? 'R$' : '$' }} {{ item.value }}</span>
          </div>
          <div class="col-lg-5 col-12 d-w">
            <span class="value-day"
              >({{ translateFreeTour.PlanValueDay }} {{ translateFreeTour.current
              }}{{ decimalParaCentavos(item.in_cents) }}/{{ translateFreeTour.day }})</span
            >
          </div>
        </div>
      </div>
      <div class="col-2">
        <div class="d-w-btn">
          <button @click="redirect('AssineOptionsPage')">
            {{ translateFreeTour.buttonSubscribe }} <i class="icon-arrow-right"></i>
          </button>
        </div>
      </div>
      <hr v-if="showTitle" class="hr m-3 hr-blurry" />
      <hr v-else class="hr m-1 hr-blurry" />
    </div>
  </div>
</template>

<script lang="ts">
  import { mapState } from 'pinia'
  import { defineComponent } from 'vue'
  import { localeStore } from 'stores/locale'
  import translateFreeTour from 'tradutors/freetour'
  import router from 'router'
import { query } from 'vue-gtag'
  export default defineComponent({
    name: 'SubscribePlans',
    props: ['plans', 'showTitle', 'acionador'],
    computed: {
      ...mapState(localeStore, ['locale']),
      translateFreeTour: function () {
        if (this.locale === 'pt-br') {
          return translateFreeTour.portugues
        } else {
          return translateFreeTour.ingles
        }
      }
    },
    methods: {
      decimalParaCentavos: function (numeroDecimal) {
        // Divide o número decimal por 100 para obter o valor em centavos
        var valorCentavos = Number(numeroDecimal) / 100

        // Formata o valor com duas casas decimais
        var valorFormatado = valorCentavos.toFixed(2)

        // Retorna o valor formatado como uma string
        return valorFormatado.replace('.', ',')
      },
      redirect(name) {
        router.push({
          name,
          params: {
            locale: this.locale,
          },
          query: {
            acionador: this.$route.name
          }
        })
      }
    }
  })
</script>

<style scoped lang="css">
  .row > [class*='col-'] {
    padding: 2px 2px;
    margin-left: 5px;
  }

  .orange-title {
    height: 41px;
    color: #ff6000;
    font-family: 'Roboto-Bold';
    font-size: 35px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 41px;
  }

  .black-title {
    height: 28px;
    color: #000000;
    font-family: 'Roboto-Bold';
    font-size: 24px;
    font-style: italic;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 28px;
  }

  .subtitle span {
    height: 20px;
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
  }

  .discont-w {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #6ca727;
    padding: 5px;
    border-radius: 20px;
    text-align: center;
    height: 33px;
  }

  .discont {
    color: #ffffff;
    font-family: 'Roboto-Bold';
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
  }

  .plan-name {
    color: #000000;
    font-family: 'Roboto-Medium';
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0;
  }

  .d-w {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .d-w-2 {
    text-align: center;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .value {
    color: #b20000;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
  }

  .value-day {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 11px;
    letter-spacing: 0;
  }

  .d-w-btn button {
    color: #fff;
  }

  .d-w-btn {
    background: #000;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-family: 'Exo-2';
    font-size: 16px;
    letter-spacing: 0;
    width: 132px;
    padding: 2px;
  }
  @media screen and (max-width: 769px) {
    .title,
    .subtitle {
      display: none;
    }

    .d-w-btn {
      width: unset;
    }

    .col-4 {
      width: 25%;
    }
    .col-5 {
      width: 36%;
    }
    .col-2 {
      width: 30%;
    }
  }
</style>
